export default __webpack_public_path__ + "static/brand-12-5d7be7e63cf2bc21be416e7b0a78623a.png";